import React, { Fragment } from "react";
import styled from 'styled-components';
import I10n from '../../../features/i10n';
import MsxIcons from '../../msx-icons';
import Scrollbars from 'react-custom-scrollbars';
import { front_base_url, configurationModuleType, busExpansionType, zelio_extension, m172_ranges, m172_battery_backup, pacdrive_ranges, tm172sig_type, m171_need_amb, tm171_communication_module_type, m171_ranges } from '../../../constants';
import { formatLengthUnit } from '../../../utils/data-formatter';
import DimensionRule from '../../../components/dimension-rule';
import Device from '../../../models/Device';
import IOIsland from '../../../models/IOIsland';
import Configuration from '../../../models/Configuration';
import { PRIMARY_COLOR, SECONDARY_COLOR } from "../../../color-constants";


const Container = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: white;
  color: #333333;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background-color: white;
  color: ${PRIMARY_COLOR};
  color: var(--se-primary, ${PRIMARY_COLOR});
  margin: 0px 20px;
  padding: 10px 0px;
`;

const Subtitle = styled.div`
  font-size: 14px;
  color: #626469;
  margin-top: 5px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

const Title = styled.span`
  font-weight: bold;
  font-size: 20px;
`;

const CloseIcon = styled.span`
  display: inline-block;
  color: #626469;
  cursor: pointer;
`;

const Content = styled.div`
  flex: 1 1 0px;
  display: flex;
  margin: 10px 0px;
  overflow: hidden;
  background-color: #fafafa;
  box-shadow: inset 0 0 15px 1px rgba(0,0,0,0.1);

  border-top: 2px solid #cccccc;
`;

const InlineRow = styled.div`
  position: relative;
  display: inline-block;
  ${props => props.paddingLeft ? `padding-left: ${props.paddingLeft}px;` : ''}
  ${props => props.paddingRight ? `padding-right: ${props.paddingRight}px;` : ''}
`;

const ScrollbarContent = styled.div`
  display: inline-block;
  margin: ${props => props.showDimensions ? 30 : 15}px 15px 15px 15px;
`;

const GraphicalViewItem = styled.div`
  position: relative;
  height: 100%;
`;

const BlockWrapper = styled.div`
  display: inline-block;
`;

const BlockWithDimension = styled.div`
  position: relative;
  display : inline-block;
`;

const BlockModulesWrapper = styled.div`
  display: inline-block;
`;

const ModuleWithBusWrapper = styled.div`
  display: inline-block;
`;

const ModuleItem = styled(GraphicalViewItem)`
  display: inline-block;
  height: ${props => props.height ? props.height : 160}px;
  z-index: 1;
  position: relative;
`;

const ModuleInput = styled.input`
  position: absolute;
  opacity: 0.00001;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  z-index: -1;
`;

const DeviceImageWrapper = styled.label`
  display: block;
  position: relative;

  :after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    box-sizing: border-box;

    ${props => props.selected && `
      border: 4px solid ${PRIMARY_COLOR};
      border-radius: 2px;
      background-color: rgba(66, 180, 230, 0.25);
    `}
  }
`;

const DeviceImage = styled.img`
  display: block;
  height: ${props => `${props.height}px`};
  width: ${props => `${props.width}px`};
  font-size: 8px;
  writing-mode: vertical-lr;
  text-orientation: upright;
  text-align: center;
`;
const SlottedDeviceImage = styled(DeviceImage)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`;
const CartridgeImage = styled(DeviceImage)`
  position: absolute;
  top: 0;
  left: 0;
`;

const CableItem = styled(GraphicalViewItem)`
  display: inline-block;
  vertical-align: top;
  height: ${props => props.height ? props.height : 160}px;
`;

const Cable = styled.div`
  position: relative;
  width: ${props => props.size === 'small' ? '35px' : '70px'};
  height: 5px;
  border-radius: 2px;
  margin: -10px -10px 0;
  background-color: ${PRIMARY_COLOR};
  background-color: var(--se-secondary, ${PRIMARY_COLOR});
  z-index: 2;
  ${props => props.position === 'top' ? 'margin-top: 25px;' : 'top: 50%;'}
`;

const M172WireStart = styled.div`
  box-sizing: content-box;
  position: absolute;
  width: ${props => props.width}px;
  height: 100px;
  margin-left: 50%;
  ${props => props.isRS485 ?
    `
    bottom: -35px;
    ${props.forCom ? `
      border-right: 5px solid ${SECONDARY_COLOR};
      border-right: 5px solid var(--se-primary, ${SECONDARY_COLOR});
      margin-left: 0px;
    ` : `
      border-left: 5px solid ${SECONDARY_COLOR};
      border-left: 5px solid var(--se-primary, ${SECONDARY_COLOR});
    `}
    border-bottom: 5px solid ${SECONDARY_COLOR};
    border-bottom: 5px solid var(--se-primary, ${SECONDARY_COLOR});
    `
    :
    `bottom: -15px;
    border-left: 5px solid ${PRIMARY_COLOR};
    border-left: 5px solid var(--se-secondary, ${PRIMARY_COLOR});
    border-bottom: 5px solid ${PRIMARY_COLOR};
    border-bottom: 5px solid var(--se-secondary, ${PRIMARY_COLOR});
    `
  }
`;

const M172WireLabel = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  font-size: 12px;
`;

const M172WireMiddleWrapper = styled.div`
  box-sizing: content-box;
  position: absolute;
  width: ${props => props.width}px;
  ${props => props.isRS485 ?
    `bottom: -35px;` :
    `bottom: -15px;`
  }
`;

const M172WireLineH = styled.div`
  box-sizing: content-box;
  width: ${props => props.width}px;
  height: 15px;
  ${props => props.isRS485 ?
    `
    border-bottom: 5px solid ${SECONDARY_COLOR};
    border-bottom: 5px solid var(--se-primary, ${SECONDARY_COLOR});
    `:
    `
    border-bottom: 5px solid ${PRIMARY_COLOR};
    border-bottom: 5px solid var(--se-secondary, ${PRIMARY_COLOR});
    `
  }
`;

const M172WireLineV = styled.div`
  box-sizing: content-box;
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 5px;
  ${props => props.isRS485 ?
    `
    background-color: ${SECONDARY_COLOR};
    background-color: var(--se-primary, ${SECONDARY_COLOR});
    height: ${props.height + 20}px;
    `:
    `
    background-color: ${PRIMARY_COLOR};
    background-color: var(--se-secondary, ${PRIMARY_COLOR});
    height: ${props.height}px;
    `
  }
`;

const M172WireEnd = styled.div`
  box-sizing: content-box;
  position: absolute;
  width: ${props => props.width}px;
  height: 100px;

  ${props => props.isRS485 ?
    `
    ${props.forCom ? `
      border-left: 5px solid ${SECONDARY_COLOR};
      border-left: 5px solid var(--se-primary, ${SECONDARY_COLOR});
      margin-left: 50%;
    ` : `
      border-right: 5px solid ${SECONDARY_COLOR};
      border-right: 5px solid var(--se-primary, ${SECONDARY_COLOR});
    `}
    border-bottom: 5px solid ${SECONDARY_COLOR};
    border-bottom: 5px solid var(--se-primary, ${SECONDARY_COLOR});
    bottom: -35px;
    `:
    `
    border-right: 5px solid ${PRIMARY_COLOR};
    border-right: 5px solid var(--se-secondary, ${PRIMARY_COLOR});
    border-bottom: 5px solid ${PRIMARY_COLOR};
    border-bottom: 5px solid var(--se-secondary, ${PRIMARY_COLOR});
    bottom: -15px;
    `
  }
`;

const protocolColors = {
  "Modbus SL": "black",
  "Modbus TCP": "#3DCD58",
  "CANopen": "#7A30A0",
  "EtherNet/IP": "#3DCD58",
  "Sercos": "#B10043"
};

class ModalPreviewConfiguration extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showDimensions: true,
    }
  }

  // On mount and if there is a module hightlighted, scroll to this module
  componentDidMount() {
    if (this._highlightedModuleElement && this._scrollElement) {

      this._scrollElement.view.scrollTop = Math.max(0, (this._highlightedModuleElement.getBoundingClientRect().y - 100.0));
      this._scrollElement.view.scrollLeft = Math.max(0, (this._highlightedModuleElement.getBoundingClientRect().x - 70.0));
    }
  }

  renderCable = (islandMaxHeight, position = 'center', size = 'medium') => {
    const cableProps = {
      height: islandMaxHeight,
      position,
      size,
    };
    return (
      <CableItem {...cableProps}>
        <Cable {...cableProps}></Cable>
      </CableItem>
    )
  }

  canShowM172Wiring = (configuration) => {
    return m172_ranges.includes(configuration.headModule.rangeOfProduct) || m171_ranges.includes(configuration.headModule.rangeOfProduct);
  }

  canShowPacdriveWiring = (configuration) => {
    return pacdrive_ranges.includes(configuration.headModule.rangeOfProduct);
  }

  renderPacdriveWiring = (device, moduleType, imageHeight, imageWidth, islandMaxHeight, lastModuleSlot, configuration) => {
    return (
      <>
        {this.canShowPacdriveWiring(configuration) && this.props.configuration.ioModules.length > 0 &&
          <>
            {moduleType === configurationModuleType.head_module && <>

              {<M172WireStart forCom={false} isRS485={false} width={40}>
                <M172WireLabel>{I10n.get('screen.wiring.pacnet')}</M172WireLabel>
              </M172WireStart>}
            </>}
            {moduleType === configurationModuleType.io_module &&
              <>
                {device.slot < lastModuleSlot &&
                  <M172WireMiddleWrapper isRS485={false} width={imageWidth + 10}>
                    <M172WireLineH isRS485={false} width={imageWidth + 10}></M172WireLineH>
                    {<M172WireLineV isRS485={false} height={(30 + (islandMaxHeight - imageHeight))}></M172WireLineV>}
                  </M172WireMiddleWrapper>
                }
                {(device.slot === lastModuleSlot) &&
                  <M172WireEnd forCom={false} isRS485={false} width={imageWidth / 2.0}></M172WireEnd>
                }
              </>
            }
          </>
        }
      </>
    );
  }

  renderM172SIGWiring = (device, moduleType, productType, imageHeight, imageWidth, lastM172SIGModuleSlot) => {
      return <>
    {moduleType === configurationModuleType.head_module && <M172WireStart forCom={true} isRS485={true} width={imageWidth / 2.0}>
    </M172WireStart>}
    {moduleType === configurationModuleType.com_module  &&
        <>
          {device.slot < lastM172SIGModuleSlot &&
              <M172WireMiddleWrapper isRS485={true} width={imageWidth}>
                <M172WireLineH isRS485={true} width={imageWidth + 20}></M172WireLineH>
                {tm171_communication_module_type === productType && <M172WireLineV
                          isRS485={true}
                          height={30 + (160 - imageHeight)}
                    ></M172WireLineV>}
              </M172WireMiddleWrapper>
          }
          {tm171_communication_module_type !== productType && device.slot === lastM172SIGModuleSlot &&
            <M172WireEnd forCom={true} isRS485={true} width={(imageWidth / 2.0) + 20}>
                <M172WireLabel>{I10n.get('screen.wiring.rs485')}</M172WireLabel>
            </M172WireEnd>
          }
        </>
    }
    </>;
  }


  renderM172Wiring = (device, moduleType, productType, imageHeight, imageWidth, islandMaxHeight, lastM172RS485ModuleSlot, lastNonM172RS485ModuleSlot, configuration, lastM172SIGModuleSlot) => {
    return (
      <>
        {this.canShowM172Wiring(configuration) && this.props.configuration.ioModules.length > 0 &&
          <>
            {moduleType === configurationModuleType.head_module && <>
              {lastM172RS485ModuleSlot > -1 && <M172WireStart forCom={false} isRS485={true} width={imageWidth / 2.0 + 20}>
                {(lastM172SIGModuleSlot === -1 || m171_need_amb === productType) && <M172WireLabel>{I10n.get('screen.wiring.rs485')}</M172WireLabel>}
              </M172WireStart>}
              {lastNonM172RS485ModuleSlot > -1 && <M172WireStart isRS485={false} width={imageWidth / 2.0 + 20}>
                <M172WireLabel>{m171_ranges.includes(device.rangeOfProduct) ? I10n.get("screen.wiring.lan") :  I10n.get("screen.wiring.canbus")}</M172WireLabel>
              </M172WireStart>}
            </>}
            {moduleType === configurationModuleType.io_module &&
              <>
                {device.slot < lastNonM172RS485ModuleSlot &&
                  <M172WireMiddleWrapper isRS485={false} width={imageWidth + 10}>
                    <M172WireLineH isRS485={false} width={imageWidth + 10}></M172WireLineH>
                    {productType !== m172_battery_backup && !device.isM172RS485Module() && <M172WireLineV isRS485={false} height={(30 + (islandMaxHeight - imageHeight))}></M172WireLineV>}
                  </M172WireMiddleWrapper>
                }
                {device.slot < lastM172RS485ModuleSlot &&
                  <M172WireMiddleWrapper isRS485={true} width={imageWidth + 10}>
                    <M172WireLineH isRS485={true} width={imageWidth + 10}></M172WireLineH>
                    {productType !== m172_battery_backup && device.isM172RS485Module() && <M172WireLineV isRS485={true} height={(30 + (islandMaxHeight - imageHeight))}></M172WireLineV>}
                  </M172WireMiddleWrapper>
                }
                {(device.slot === lastM172RS485ModuleSlot || device.slot === lastNonM172RS485ModuleSlot) &&
                  <M172WireEnd forCom={false} isRS485={device.slot === lastM172RS485ModuleSlot} width={imageWidth / 2.0}></M172WireEnd>
                }
              </>
            }
          </>
        }
      </>
    );
  }

  computeModuleHeight = (realHeight, maxModuleHeight) => {
    const heightRatio = Math.ceil(100 * realHeight / maxModuleHeight) / 100;
    return 160 * (heightRatio ? heightRatio : 1);
  }

  computeModuleWidth = (realWidth, realHeight, newHeight) => {
    const aspectRatio = realWidth / realHeight;
    return newHeight * (aspectRatio ? aspectRatio.toFixed(2) : 1);
  }

  shouldModuleBeHighlighted = (moduleSlot, moduleType, moduleIslandSlot) => {
    let result = false;

    if (this.props.moduleToHighlightProps != null && this.props.moduleToHighlightProps.moduleSlot != null && this.props.moduleToHighlightProps.moduleType != null && this.props.moduleToHighlightProps.moduleIslandSlot != null) {
      if (this.props.moduleToHighlightProps.moduleSlot === moduleSlot && this.props.moduleToHighlightProps.moduleType === moduleType && this.props.moduleToHighlightProps.moduleIslandSlot === moduleIslandSlot) {
        result = true;
      }
    }

    return result;
  }

  setHighlightedModuleRef = element => {
    this._highlightedModuleElement = element;
  };

  renderModule = (device, maxModuleHeight, maxIslandHeight, cartridges, moduleProps = {}, configuration, selected = false) => {
    const slot = device.slot;
    const moduleType = device.moduleType;
    const realHeight = device.height ? device.height : 0;
    const realWidth = device.width ? device.width : 0;
    const imageHeight = this.computeModuleHeight(realHeight, maxModuleHeight);
    const imageWidth = this.computeModuleWidth(realWidth, realHeight, imageHeight);
    const cartridgeDevices = cartridges.map(d => new Device(d)).sort((a, b) => a.slot - b.slot);
    const slottedDevicesImages = device.getSlottedDevicesFrontImageLinks();
    const lastModule = this.props.configuration.modules().slice(-1)[0];
    const lastM172RS485ModuleSlot = this.props.configuration.findLastM172RS485ModuleSlot();
    const lastNonM172RS485ModuleSlot = this.props.configuration.findLastNonM172RS485ModuleSlot();
    const lastM172SIGModuleSlot = this.props.configuration.findLastM172SIGModuleSlot();

    const { 'item': itemProps = {}, 'image': imageProps = {} } = moduleProps;
    return (
      <>
        <ModuleItem height={maxIslandHeight} key={`${device.id}_${slot}`} {...itemProps}>
          <ModuleInput
            id={`${device.id}_${slot}`}
            type="radio" name="config_module"
            className={`${device.validator.valid ? 'valid' : 'invalid'}`}
            checked={moduleType === this.state.typeModuleSelected && slot === this.state.slotModuleSelected}
            onChange={() => {}}
          ></ModuleInput>
          <DeviceImageWrapper ref={(elt) => { if (selected) { this.setHighlightedModuleRef(elt); } }} htmlFor={`${device.id}_${slot}`} {...imageProps} selected={selected}>
            <DeviceImage
              src={`${front_base_url}/images/small-devices-images/${device.id}_h320px.png`}
              alt={`${device.id} module front view`}
              onError={(e) => { e.target.onerror = null; e.target.src = device.sidePicture }}
              height={imageHeight}
              width={imageWidth}
            >
            </DeviceImage>
            {(!(configurationModuleType.head_module === moduleType) || [...m171_ranges, ...m172_ranges].includes(device?.rangeOfProduct)) && slottedDevicesImages.map((imgObj, i) => {
              return (
                <SlottedDeviceImage
                  key={i}
                  src={`${front_base_url}/images/small-devices-images/${imgObj.src}_h320px.png`}
                  onError={(e) => { e.target.onerror = null; e.target.src = imgObj.fallback }} alt={`${imgObj.id} module front view`}
                  height={imageHeight}
                  width={imageWidth}
                >
                </SlottedDeviceImage>
              );
            })}
            {cartridgeDevices.map((d, i) => {
              return (
                <CartridgeImage
                  key={i}
                  src={`${front_base_url}${device.baseCartridgeURL}_${d.id}_Slot${d.slot}.png`}
                  alt={`${d.id} module front view`}
                  onError={(e) => { e.target.onerror = null; e.target.src = d.sidePicture }} height={imageHeight}
                  width={imageWidth}
                >
                </CartridgeImage>
              );
            })}
          </DeviceImageWrapper>
        </ModuleItem>

        {lastM172SIGModuleSlot !== -1 && this.renderM172SIGWiring(device, moduleType, device.productType, imageHeight, imageWidth, lastM172SIGModuleSlot)}
        {this.renderM172Wiring(device, moduleType, device.productType, imageHeight, imageWidth, maxIslandHeight, lastM172RS485ModuleSlot, lastNonM172RS485ModuleSlot, configuration)}
        {this.renderPacdriveWiring(device, moduleType, imageHeight, imageWidth, maxIslandHeight, lastModule.slot, configuration)}
      </>
    );
  };

  renderHeadModule = (maxModuleHeight, islandMaxHeight, configuration, islandSlot) => {
    const device = configuration.headModule;
    const cartridges = this.props.configuration.cartridges;

    const moduleProps = { 'item': {}, 'image': {} };
    return (
      <>
        {this.renderModule(device, maxModuleHeight, islandMaxHeight, cartridges, moduleProps, configuration, this.shouldModuleBeHighlighted(device.slot, device.moduleType, islandSlot))}
      </>
    );
  }

  renderByBlocks = (maxModuleHeight, islandMaxHeight, configuration, rulePosition, islandSlot) => {
    const blocks = configuration.blocks();
    return (
      blocks.map((block, idx) => {

        const maxBlockHeight = this.computeModuleHeight(block.maxModuleHeight(), maxModuleHeight);
        return (
          <BlockWrapper key={idx}>
            {idx > 0 && this.renderCable(islandMaxHeight)}
            <BlockWithDimension>
              {this.state.showDimensions && block.hasWidth() && (
                <DimensionRule
                  text={formatLengthUnit(block.width())}
                  orientation={'horizontal'}
                  position={rulePosition}
                  offsetTop={-20}
                  offsetBottom={islandMaxHeight - maxBlockHeight - 5}
                ></DimensionRule>
              )}
              <BlockModulesWrapper>
                {block.modules.map((module, idx) => {
                  const isBoth = busExpansionType.both === module.busExpansionType;
                  return (
                    <ModuleWithBusWrapper key={idx}>
                      <InlineRow paddingRight={tm172sig_type === module.productType ? 20 : 0} paddingLeft={((this.canShowM172Wiring(configuration) || this.canShowPacdriveWiring(configuration)) && (module.moduleType === configurationModuleType.io_module) && !(module.productType === m172_battery_backup) ? (module.slot === 1 ? 20 : 10) : 0)}>
                        {isBoth && idx > 0 && this.renderCable(islandMaxHeight, 'top', 'small')}
                        {
                          module.moduleType === configurationModuleType.head_module ?
                            this.renderHeadModule(maxModuleHeight, islandMaxHeight, configuration, islandSlot)
                            :
                            this.renderModule(module, maxModuleHeight, islandMaxHeight, [], {}, configuration, this.shouldModuleBeHighlighted(module.slot, module.moduleType, islandSlot))
                        }
                        {zelio_extension === module.productType && this.renderCable(islandMaxHeight, 'center', 'small')}
                      </InlineRow>
                      {this.state.renderPowerSupplyBuses &&
                        configuration.rangeInfo.canShowPowerSupplyBuses() &&
                        <Fragment>
                          {this.renderPowerSupplyBus(module, configuration)}
                          {this.renderPowerSupplyBusSegment(module, configuration)}
                        </Fragment>}
                    </ModuleWithBusWrapper>
                  );
                })}
              </BlockModulesWrapper>
            </BlockWithDimension>
          </BlockWrapper>
        );
      })
    );
  }

  islandsConnectedToModuleWithProtocol = (module, configuration, protocolName) => {
    const islands = [];
    const configurationPLC = configuration.headModule;
    const islandsConnectedWithProtocol =
      configuration.getIslandsConnectedWithProtocol(protocolName);

    if (configurationModuleType.head_module === module.moduleType) {
      islands.push(...islandsConnectedWithProtocol);
    } else {
      islandsConnectedWithProtocol.forEach(island => {
        if (configurationPLC.masterProtocols.filter(islandProtocol => islandProtocol.name !== protocolName).length > 0) {
          islands.push(island);
        }
      });
    }
    return islands;
  }

  buildProtocolGroups = (configuration, maxModuleHeight) => {
    const protocolWithIslandsAndOffset = {};
    let currentOffset = 0;
    configuration.blocks().forEach((block, bidx) => {
      block.modules.forEach((mod) => {
        // Offset for cable.
        if (bidx > 0) {
          currentOffset += 5;
        }
        const modProtocolGroups = {};
        const graphicalModuleHeight = this.computeModuleHeight(mod.height, maxModuleHeight);
        const graphicalModuleWidth = (mod.width * this.computeModuleHeight(mod.height, maxModuleHeight)) / mod.height;
        mod.masterProtocols.forEach((protocol) => {
          const protocolName = protocol.name;
          this.islandsConnectedToModuleWithProtocol(mod, configuration, protocolName).forEach((island) => {
            if (modProtocolGroups[protocolName]) {
              modProtocolGroups[protocolName].islands.push(island);
            } else {
              modProtocolGroups[protocolName] = { islands: [island], protocolName: protocolName };
            }
          });
        });

        const nbProtocolGroups = Object.entries(modProtocolGroups).length;
        // Affect protocol groups offset.
        Object.entries(modProtocolGroups).forEach(([, modProtocolGroup], index) => {
          protocolWithIslandsAndOffset[modProtocolGroup.protocolName] = modProtocolGroup;
          protocolWithIslandsAndOffset[modProtocolGroup.protocolName].offset = currentOffset + ((graphicalModuleWidth / (nbProtocolGroups + 2)) * (index + 1));
        });

        currentOffset += (mod.width * graphicalModuleHeight) / mod.height;
      });

    });

    if (configuration.slc && protocolWithIslandsAndOffset['Sercos']) {
      protocolWithIslandsAndOffset['Sercos'].islands.push(
        new IOIsland(
          {
            configuration: new Configuration({
              name: I10n.get('saved_configuration.export.pdf_architecture.slc'),
              headModule: new Device({
                id: configuration.slc.module.id,
                height: configuration.slc?.module?.height || 99,
                width: configuration.slc?.module?.width || 87.5,
                moduleType: configurationModuleType.head_module
              })
            })
          }
        )
      );
    }

    return Object.values(protocolWithIslandsAndOffset).sort((a, b) => b.offset - a.offset);
  }

  buildProtocolLines = (protocolGroups) => {
    const protocolLines = [];
    protocolGroups.forEach((protocolGroup) => {
      let currentLine = { protocolName: protocolGroup.protocolName, offset: protocolGroup.offset, islands: [] };
      protocolGroup.islands.forEach((island) => {
        currentLine.islands.push(island);
      });
      protocolLines.push(currentLine);
    });
    return protocolLines;
  }

  generateProtocolLines = (configuration, maxModuleHeight) => {
    const protocolGroups = this.buildProtocolGroups(configuration, maxModuleHeight);
    const protocolLines = this.buildProtocolLines(protocolGroups);
    let currentView;
    while (protocolLines.length > 0) {
      const currentLine = protocolLines.shift();
      let shouldRenderBorder = true;
      let previousOffset = 0;
      if (protocolLines.length > 0) {
        previousOffset = protocolLines[0].offset;
        shouldRenderBorder = previousOffset !== currentLine.offset;
      }
      currentView = (
        <div style={{ marginLeft: currentLine.offset - previousOffset, marginBottom: 5 }}>
          <div style={{ display: "flex", flexDirection: "row", minHeight: 18 }}>
            <div style={{ borderLeft: shouldRenderBorder ? `5px solid ${protocolColors[currentLine.protocolName]}` : `0px solid ${protocolColors[currentLine.protocolName]}` }}></div>
            {currentView}
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ paddingLeft: 5, borderLeft: shouldRenderBorder ? `5px solid ${protocolColors[currentLine.protocolName]}` : `0px solid ${protocolColors[currentLine.protocolName]}`, color: protocolColors[currentLine.protocolName], fontSize: 12, }}>{currentLine.protocolName}</span>
            <div style={{ display: "flex", flexDirection: "row", marginBottom: 20 }}>
              {currentLine.islands.map((island, idx) => {
                return (
                  <div key={idx} style={{ display: "flex", flexDirection: "column" }}>

                    <div style={{ borderTop: `4px solid ${protocolColors[currentLine.protocolName]}` }}></div>
                    <div style={{ paddingLeft: 20 }}>
                      {this.generateGraphicalConfiguration(island.configuration, currentLine.protocolName, maxModuleHeight, island.slot, 'bottom')}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>);
    }

    return currentView;
  }

  generateGraphicalConfiguration = (configuration, protocolName, maxModuleHeight, islandSlot, rulePosition = 'bottom') => {
    const borderWidth = protocolName ? 5 : 0;
    const borderColor = protocolName ? protocolColors[protocolName] : 'black';
    const islandHeight = this.computeModuleHeight(configuration.maxModuleHeight(), maxModuleHeight);
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span style={{ fontSize: 14, marginLeft: 5, paddingLeft: 5, borderLeft: `${borderWidth}px solid ${borderColor}`, whiteSpace: 'nowrap' }}>
          {configuration.name}
        </span>
        <div style={{ display: "flex", flexDirection: "row", whiteSpace: "nowrap", height: islandHeight }}>
          {this.renderByBlocks(maxModuleHeight, islandHeight, configuration, rulePosition, islandSlot)}
        </div>
      </div>
    );
  }

  setScrollRef = element => {
    this._scrollElement = element;
  };

  render = () => {
    const maxModuleHeight = this.props.configuration.maxModuleHeightWithRemote();
    return (
      <Container>
        <Header id="modal-preview-config-header">
          <TitleWrapper>
            <Title>{I10n.get('screen.config_editor.preview')}</Title>
            <CloseIcon onClick={(e) => {
              e.preventDefault();
              this.props.closeModal();
            }}>
              <MsxIcons name="close"></MsxIcons>
            </CloseIcon>
          </TitleWrapper>
          <Subtitle>{I10n.getOrDefault(`modal.${this.props.configuration.starterType}.subtitle`, I10n.get('modal.subtitle'))}</Subtitle>
        </Header>
        <Content>
          <Scrollbars ref={this.setScrollRef}>
            <ScrollbarContent showDimensions={this.state.showDimensions}>
              {this.generateGraphicalConfiguration(this.props.configuration, null, maxModuleHeight, 0, 'top')}
              {this.generateProtocolLines(this.props.configuration, maxModuleHeight)}
            </ScrollbarContent>
          </Scrollbars>
        </Content>
      </Container>
    );
  }
}

export default ModalPreviewConfiguration;
